<template>
  <div class="nuttrema-widget nuttrema-widget--notices-info" v-show="!emailVerified">
    <template>
      <h4 class="nuttrema-widget__sup_title">{{ $t('label.do_not_forget') }}</h4>
      <h2 class="nuttrema-widget__title">{{ $t('label.complete_your_personal_settings') }}</h2>

      <ul class="nuttrema-widget__notes">
        <li class="is-no-hover">
          <div class="nuttrema-widget__notice">
            <div class="notice__icon">
              <nuttrema-iconica-sidebar-link icon="fal fa-at"></nuttrema-iconica-sidebar-link>
            </div>
            <div class="notice__text">
              <div class="notice__text--title">{{ $t('label.verify_email') }}</div>
              <div class="notice__text--info">
                <p>{{ $t('label.verify_email_help') }}</p>
              </div>
            </div>
            <div class="notice__action">
              <router-link
                 tag="a"
                :title="$t('label.didn_t_receive_a_verification_email_help')"
                :to="{ name: 'my-preferences-change-email' }">
                  <el-button size="mini" type="text" class="is-icon-ml-075" style="color: #4a4a4a">{{ $t('label.resend') }}<i class="fa fa-chevron-right"></i></el-button>
              </router-link>
            </div>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { get } from 'lodash';

import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import AbstractWidget from './abstract-widget';

export default {
  name: 'widget-notices-personal',
  mixins: [
    AbstractWidget,
  ],
  components: {
    NuttremaIconicaSidebarLink,
  },
  // data() {
  //   return {
  //     failures: 0,
  //     emailVerified: false,
  //   };
  // },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
    emailVerified() {
      return get(this.PersonalProfile, 'data.email_verified', true);
    },
  },
  // created() {
  //   this.failures = this.emailVerified ? 0 : 1;
  // },
};
</script>

<style lang="scss" scoped>
  @import './abstract-widget';
</style>




// WEBPACK FOOTER //
// src/components/ui/widgets/widget-notices-personal.vue